export enum sizeEnum {
    small = 'is-small',
    medium = 'is-medium',
    large = 'is-large',
}

export type Sizes = '' | sizeEnum.small | sizeEnum.medium | sizeEnum.large;
